import React from "react";

/* Note: In a form, if you press enter, the first button is essentially clicked. 
 * If say you have a cancel button & then a submit button, 
 * make sure the cancel button type is set to "button".
 * The same applies for a close/cross button in a modal.
 * Valid types: button|submit|reset */

type ButtonProps = {
    className?: string | null,
    disabled?: boolean,
    onClick?: any,
    text?: string,
    type?: "button" | "reset" | "submit" | undefined,
    colour?: string
}

const noButtonCssClassname = "unset";

const Button = (props: ButtonProps) => {
    const { className, disabled, onClick, text, type = "button", colour = "black" } = props;
    const clickHandler = (e: any) => {
        if (e != null) {
            e.preventDefault();
        }

        if (onClick != null) {
            onClick(e);
        }
    }

    const cssClassNames = ["btn"];

    if (colour !== noButtonCssClassname) {
        cssClassNames.push(`btn-${colour}`);
    }

    if (className != null) {
        cssClassNames.push(className);
    }

    cssClassNames.push(disabled ? "disabled" : "");

    const cssClassName = cssClassNames.join(" ").trim();

    return (
        <button
            className={cssClassName}
            type={type}
            disabled={disabled}
            onClick={clickHandler}
        >{text}</button>
    )
};

export default Button;
